// src/components/Header.js
import React, { useState, useEffect } from 'react';

const Header = () => {
  const [isModalOpen, setIsModalOpen] = useState(false);

  // Блокировка прокрутки при открытом модальном окне
  useEffect(() => {
    if (isModalOpen) {
      document.body.style.overflow = 'hidden';
    } else {
      document.body.style.overflow = 'unset';
    }

    // Очистка при размонтировании
    return () => {
      document.body.style.overflow = 'unset';
    };
  }, [isModalOpen]);

  const openModal = () => setIsModalOpen(true);
  const closeModal = () => setIsModalOpen(false);

  const handleExternalQuestion = () => {
    window.open('https://max.ru/join/lbhx3dHqBqzkfFaYjfQc0zMDfNTIbbFwGq3Hu5gTOxc', '_blank');
    closeModal();
  };

  // Закрытие по клику на оверлей
  const handleOverlayClick = (e) => {
    if (e.target === e.currentTarget) {
      closeModal();
    }
  };

  return (
    <>
      <div className="header">
        <h1>Мониторинг школьного питания Санкт-Петербурга</h1>
        <p>Анализ качества организации питания в образовательных учреждениях</p>
      </div>
      
      {/* Кнопка */}
      <button 
        onClick={openModal}
        className="question-button-fixed"
      >
        ?
      </button>

      {/* Модальное окно */}
      {isModalOpen && (
        <div className="modal-overlay-custom" onClick={handleOverlayClick}>
          <div className="modal-content-custom">
            <div className="modal-header-custom">
              <h2>Проблема: Данные на федеральном портале не обновляются</h2>
              <button className="close-button-custom" onClick={closeModal}>×</button>
            </div>
            
            <div className="modal-body-custom">
              <p className="modal-intro-custom">
                Если вы загрузили на сайт образовательного учреждения (ОУ) новые файлы, но на федеральном сайте мониторинга (<a href="https://monitoring.cemon.ru" target="_blank">https://monitoring.cemon.ru</a>) отображаются старые данные, проверьте следующие пункты.
              </p>

              <div className="problem-section-custom">
                <h3>1. Проблема: Не обновляется типовое меню (tm2025-sm.xlsx)</h3>
                <p><strong>Что проверить:</strong></p>
                <ul>
                  <li><strong>Шаблон:</strong> Вы использовали актуальный шаблон Excel с сайта <a href="https://monitoring.cemon.ru/#/help?" target="_blank">https://monitoring.cemon.ru/#/help?</a></li>
                  <li><strong>Срок загрузки:</strong> Вы выложили файл на сайт ОУ до 18:00 предыдущего дня?</li>
                  <li className="important-custom">Важно: Сервер не обрабатывает файлы по пятницам и субботам.</li>
                  <li><strong>Дата в файле:</strong> В самом файле Excel заполнена ячейка с датой утверждения меню?</li>
                  <li className="important-custom">Важно: Эта дата должна быть не раньше даты последнего успешно загруженного меню.</li>
                  <li><strong>Размещение:</strong> Файл с точно таким именем tm2025-sm.xlsx лежит в нужной (указанной в технических требованиях) папке на сайте вашего ОУ?</li>
                </ul>
              </div>

              <div className="problem-section-custom">
                <h3>2. Проблема: Не обновляется календарь питания (kp2026.xlsx)</h3>
                <p><strong>Что проверить:</strong></p>
                <ul>
                  <li><strong>Шаблон:</strong> Вы использовали актуальный шаблон Excel с сайта <a href="https://monitoring.cemon.ru/#/help" target="_blank">https://monitoring.cemon.ru/#/help</a>?</li>
                  <li><strong>Срок загрузки:</strong> Вы выложили файл на сайт ОУ до 18:00 предыдущего дня?</li>
                  <li className="important-custom">Важно: Обработки в пятницу и субботу нет.</li>
                  <li><strong>Год в файле:</strong> В самом файле Excel заполнена ячейка с годом?</li>
                  <li><strong>Размещение:</strong> Файл с точно таким именем kp2025.xlsx лежит в нужной папке на сайте вашего ОУ?</li>
                </ul>
              </div>

              <div className="problem-section-custom">
                <h3>3. Проблема: Не обновляются данные родительского контроля (findex.xlsx)</h3>
                <p><strong>Что проверить:</strong></p>
                <ul>
                  <li><strong>Шаблон:</strong> Вы использовали актуальный шаблон Excel с сайта <a href="https://monitoring.cemon.ru/#/help" target="_blank">https://monitoring.cemon.ru/#/help</a>?</li>
                  <li><strong>Содержимое:</strong> Новый файл содержит новые данные (например, результаты другой проверки), а не просто измененную дату?</li>
                  <li><strong>Срок загрузки:</strong> Вы выложили файл на сайт ОУ до 18:00 предыдущего дня?</li>
                  <li className="important-custom">Важно: Обработки в пятницу и субботу нет.</li>
                  <li><strong>Дата в файле:</strong> В самом файле Excel заполнена дата проведения контроля?</li>
                  <li><strong>Размещение:</strong> Файл с точно таким именем findex.xlsx лежит в нужной папке на сайте вашего ОУ?</li>
                </ul>
              </div>

              <div className="general-rule-custom">
                <h4>Общее правило:</h4>
                <p>
                  Федеральный сервер "забирает" данные с сайтов ОУ один раз в сутки, в будние дни, до 18:00. 
                  Убедитесь, что все исправления вы делаете с запасом до этого времени.
                </p>
              </div>

              <div className="modal-actions-custom">
                <button className="external-question-button-custom" onClick={handleExternalQuestion}>
                  Данный материал изучен, хочу задать вопрос
                </button>
              </div>
            </div>
          </div>
        </div>
      )}

      <style jsx>{`
        .question-button-fixed {
          /* Позиционирование */
          position: fixed !important;
          bottom: 30px !important;
          right: 30px !important;
          z-index: 1000 !important;
          
          /* Размеры - компактный круг */
          display: flex !important;
          align-items: center !important;
          justify-content: center !important;
          width: 60px !important;
          height: 60px !important;
          padding: 0 !important;
          
          /* Внешний вид */
          background: linear-gradient(135deg, #3498db, #2980b9) !important;
          color: white !important;
          text-decoration: none !important;
          border-radius: 50% !important;
          border: 2px solid white !important;
          font-size: 24px !important;
          font-weight: bold !important;
          
          /* Эффекты */
          box-shadow: 0 6px 20px rgba(52, 152, 219, 0.4) !important;
          transition: all 0.3s ease !important;
          cursor: pointer !important;
          animation: float 3s ease-in-out infinite !important;
        }
        
        .question-button-fixed:hover {
          background: linear-gradient(135deg, #2980b9, #21618c) !important;
          transform: translateY(-3px) scale(1.1) !important;
          box-shadow: 0 10px 30px rgba(52, 152, 219, 0.6) !important;
          animation: none !important;
        }
        
        @keyframes float {
          0%, 100% { transform: translateY(0) rotate(0deg); }
          50% { transform: translateY(-6px) rotate(1deg); }
        }

        /* Индивидуальные стили для модального окна */
        .modal-overlay-custom {
          position: fixed;
          top: 0;
          left: 0;
          right: 0;
          bottom: 0;
          background: rgba(0, 0, 0, 0.7);
          display: flex;
          align-items: center;
          justify-content: center;
          z-index: 2000;
          padding: 20px;
          backdrop-filter: blur(4px);
        }

        .modal-content-custom {
          background: white;
          border-radius: 16px;
          max-width: 800px;
          width: 100%;
          max-height: 90vh;
          overflow-y: auto;
          box-shadow: 0 25px 50px rgba(0, 0, 0, 0.25);
          animation: modalAppearCustom 0.3s cubic-bezier(0.175, 0.885, 0.32, 1.275);
          border: 1px solid #e1e8ed;
        }

        @keyframes modalAppearCustom {
          from {
            opacity: 0;
            transform: scale(0.8) translateY(30px);
          }
          to {
            opacity: 1;
            transform: scale(1) translateY(0);
          }
        }

        .modal-header-custom {
          display: flex;
          justify-content: space-between;
          align-items: flex-start;
          padding: 28px;
          border-bottom: 1px solid #e1e8ed;
          background: linear-gradient(135deg, #667eea 0%, #764ba2 100%);
          color: white;
          border-radius: 16px 16px 0 0;
        }

        .modal-header-custom h2 {
          margin: 0;
          font-size: 22px;
          font-weight: 600;
          flex: 1;
          margin-right: 20px;
          line-height: 1.3;
        }

        .close-button-custom {
          background: rgba(255, 255, 255, 0.2);
          border: none;
          font-size: 28px;
          cursor: pointer;
          color: white;
          padding: 0;
          width: 36px;
          height: 36px;
          display: flex;
          align-items: center;
          justify-content: center;
          border-radius: 50%;
          transition: all 0.3s ease;
          backdrop-filter: blur(10px);
        }

        .close-button-custom:hover {
          background: rgba(255, 255, 255, 0.3);
          transform: rotate(90deg);
        }

        .modal-body-custom {
          padding: 28px;
          background: #fafbfc;
        }

        .modal-intro-custom {
          font-size: 16px;
          line-height: 1.6;
          color: #4a5568;
          margin-bottom: 28px;
          padding: 20px;
          background: white;
          border-radius: 12px;
          border-left: 5px solid #667eea;
          box-shadow: 0 2px 10px rgba(0, 0, 0, 0.05);
        }

        .problem-section-custom {
          margin-bottom: 32px;
          padding: 24px;
          background: white;
          border-radius: 12px;
          border: 1px solid #e2e8f0;
          box-shadow: 0 2px 8px rgba(0, 0, 0, 0.04);
          transition: transform 0.2s ease;
        }

        .problem-section-custom:hover {
          transform: translateY(-2px);
          box-shadow: 0 4px 15px rgba(0, 0, 0, 0.08);
        }

        .problem-section-custom h3 {
          color: #2d3748;
          margin-top: 0;
          margin-bottom: 18px;
          font-size: 18px;
          font-weight: 600;
          border-bottom: 2px solid #667eea;
          padding-bottom: 10px;
        }

        .problem-section-custom ul {
          margin: 16px 0;
          padding-left: 24px;
        }

        .problem-section-custom li {
          margin-bottom: 10px;
          line-height: 1.6;
          color: #4a5568;
          position: relative;
        }

        .problem-section-custom li strong {
          color: #2d3748;
        }

        .important-custom {
          color: #c53030;
          font-weight: 600;
          background: #fed7d7;
          padding: 8px 12px;
          border-radius: 8px;
          margin: 12px 0;
          border-left: 4px solid #c53030;
          font-size: 14px;
        }

        .general-rule-custom {
          background: linear-gradient(135deg, #c6f6d5, #b2f5ea);
          padding: 24px;
          border-radius: 12px;
          border-left: 5px solid #38a169;
          margin: 32px 0;
          box-shadow: 0 4px 12px rgba(72, 187, 120, 0.15);
        }

        .general-rule-custom h4 {
          color: #22543d;
          margin-top: 0;
          margin-bottom: 12px;
          font-size: 18px;
          font-weight: 600;
        }

        .general-rule-custom p {
          color: #22543d;
          margin: 0;
          line-height: 1.6;
          font-size: 15px;
        }

        .modal-actions-custom {
          text-align: center;
          margin-top: 36px;
          padding-top: 28px;
          border-top: 1px solid #e2e8f0;
        }

        .external-question-button-custom {
          background: linear-gradient(135deg, #ed64a6, #d53f8c);
          color: white;
          border: none;
          padding: 14px 32px;
          border-radius: 10px;
          font-size: 15px;
          font-weight: 600;
          cursor: pointer;
          transition: all 0.3s ease;
          box-shadow: 0 4px 15px rgba(237, 100, 166, 0.3);
          letter-spacing: 0.5px;
        }

        .external-question-button-custom:hover {
          background: linear-gradient(135deg, #d53f8c, #b83280);
          transform: translateY(-3px);
          box-shadow: 0 8px 25px rgba(237, 100, 166, 0.4);
        }

        /* Стили для скроллбара в модальном окне */
        .modal-content-custom::-webkit-scrollbar {
          width: 8px;
        }

        .modal-content-custom::-webkit-scrollbar-track {
          background: #f1f1f1;
          border-radius: 0 16px 16px 0;
        }

        .modal-content-custom::-webkit-scrollbar-thumb {
          background: #c1c1c1;
          border-radius: 4px;
        }

        .modal-content-custom::-webkit-scrollbar-thumb:hover {
          background: #a8a8a8;
        }
      `}</style>
    </>
  );
};

export default Header;